/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const toSize = (value) => {
	if (value === null || value === undefined) return undefined;
	return typeof value === 'number' ? `${value}px` : value;
};

const Skeleton = ({ as: Tag, className, width, height, rounded, circle, ariaLabel, ...props }) => {
	return (
		<Tag
			aria-hidden={ariaLabel ? undefined : 'true'}
			aria-label={ariaLabel}
			className={classNames(
				'skeleton',
				'bg-gray-200',
				'dark:bg-gray-700',
				'animate-pulse',
				{
					'rounded-circle': circle,
					'rounded-0': rounded === 'none',
					'rounded-1': rounded === 'sm',
					'rounded-2': rounded === 'md',
					'rounded-3': rounded === 'lg',
					'rounded-pill': rounded === 'pill',
				},
				className,
			)}
			style={{
				width: toSize(width),
				height: toSize(height),
			}}
			{...props}
		/>
	);
};

Skeleton.propTypes = {
	as: PropTypes.elementType,
	className: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	rounded: PropTypes.oneOf(['none', 'sm', 'md', 'lg', 'pill']),
	circle: PropTypes.bool,
	ariaLabel: PropTypes.string,
};

Skeleton.defaultProps = {
	as: 'div',
	className: null,
	width: '100%',
	height: '1rem',
	rounded: 'md',
	circle: false,
	ariaLabel: null,
};

export const SkeletonLine = ({ className, width, height, ...props }) => (
	<Skeleton
		className={classNames('skeleton-line', className)}
		width={width}
		height={height}
		rounded='pill'
		{...props}
	/>
);

SkeletonLine.propTypes = {
	className: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SkeletonLine.defaultProps = {
	className: null,
	width: '100%',
	height: '0.875rem',
};

export const SkeletonCircle = ({ className, size, ...props }) => (
	<Skeleton
		className={classNames('skeleton-circle', className)}
		width={size}
		height={size}
		circle
		{...props}
	/>
);

SkeletonCircle.propTypes = {
	className: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SkeletonCircle.defaultProps = {
	className: null,
	size: '2.5rem',
};

export default Skeleton;
/* eslint-enable react/jsx-props-no-spreading */
